// ----------------------------------------------------------------------
export var Avatar = function Avatar(_ref) {
  var theme = _ref.theme;
  return {
    MuiAvatarGroup: {
      styleOverrides: {
        avatar: {
          fontSize: 14,
          color: theme.palette.primary.main,
          fontWeight: theme.typography.fontWeightMedium,
          backgroundColor: theme.palette.primary.lighter
        }
      }
    }
  };
};